import { Link } from "@mui/material"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { DetailedProductGroups } from "../../priceListTypes"
import { useScopeSelection } from "./useScopeSelection"

type ScopeSelectAllLinkProps = Readonly<{
    productGroups: ReadonlyArray<DetailedProductGroups>
}>

export function ScopeSelectAllLink({ productGroups }: ScopeSelectAllLinkProps) {
    const { isEverythingSelected, toggleAll } = useScopeSelection(productGroups)

    return (
        <LocalizedStrict
            id={isEverythingSelected ? "adjust-price-list-scope-deselect-all" : "adjust-price-list-scope-select-all"}
        >
            <Link component="button" type="button" variant="body2" onClick={toggleAll}>
                {isEverythingSelected ? "Deselect all" : "Select all"}
            </Link>
        </LocalizedStrict>
    )
}
